const BACKEND_URL = `https://blackjack-pilot-api.herokuapp.com`;

export const API_PRODUCT_DETAILS = `${BACKEND_URL}/products/2`;
export const GENERATE_API_MILESTONE_URL = ({ epicId }) => `${BACKEND_URL}/products/1/epics/${epicId}/milestones`;

// will I get promoted to SDE1 because of this line?
export const isMobile = window.innerWidth < 760;